<template>
  <div>
    <p>
      <v-popover
        v-if="(orderDetail?.extra_data?.comments ?? []).length"
        class="d-inline"
        :auto-hide="true"
        placement="bottom"
      >
        <i class="comment_tooltip_fa icon-fa icon-fa-info-circle"></i>
        <template slot="popover">
          <p v-for="c in orderDetail.extra_data.comments">{{ c.text }}</p>
        </template>
      </v-popover>
      <span v-if="orderDetail.new_drug.cool"><i
        class="cool_mark_list icon icon-snowflake">&nbsp;</i></span>{{ orderDetail.new_drug.title }}
      ({{ orderDetail.drug_id }})
    </p>
    <template v-if="+orderDetail.new_drug.pack_set !== 1">
      <p><strong>{{ Math.round(orderDetail.qty / orderDetail.new_drug.pack_set * 100) / 100 }}</strong> (компл) *
        <strong>{{ orderDetail.price * orderDetail.new_drug.pack_set }}</strong></p>
      <p>
        <strong>{{ orderDetail.qty }}</strong> завод.упак. <strong>x {{ orderDetail.price }}</strong>
      </p>
    </template>
    <template v-else>
      <p><strong>x {{ orderDetail.qty }} x {{ orderDetail.price }}</strong>
        <span v-if="order.currency_id && order.currency_id !== $platformConstants.operationCurrency.id"> (<strong>{{
            orderDetail.currency_price
          }}</strong> {{ $AllCurrencies[order.currency_id]?.currency }})</span>
      </p>
    </template>
    <div class="flex flex_gap_10">
      <div v-if="showOutsorceOrder">
        <v-popover
          :auto-hide="true"
          placement="left"
        >
          <span class="badge badge-danger pointer">заказ с сайта</span>
          <template slot="popover">
            <p>{{ request.title }}</p>
            <p><strong>{{ request.qty }}</strong>уп. по <strong>{{ request.price }}</strong>р
              (<strong>{{ request.qty * request.price }}</strong>р)</p>
          </template>
        </v-popover>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['orderDetail', 'order'],
  data() {
    return {
      showOutsorceOrder: false,
      request: null,
    }
  },
  computed: {
    $AllCurrencies() {
      return this.$store.getters['platform/currencies']
    },
  },
  created() {
    if (this.order?.extra_options?.extra_drugs) {
      this.request = this.order.extra_options.extra_drugs.find((d) => d.drug_id === this.orderDetail.drug_id);
      if (!this.request) return;
      if (!this.order.extra_options.catalogOrder.use_packing) return;
      this.showOutsorceOrder = true;
    }
  }
}

</script>

<style scoped>
.cool_mark_list.icon-snowflake {
  display: inline-block;
  width: 15px;
  height: 17px;
  background: #5bbfde;
  margin: -3px 4px;
}

.comment_tooltip_fa {
  font-size: 20px;
  color: #5bbfde;
  cursor: pointer;
  height: 25px;
  vertical-align: middle;
}
</style>
